import getNeedsModifiedScrollbars from "selectors/device/getNeedsModifiedScrollbars";
import ScrollAreaComponent from "components/ScrollAreaComponent";
import { compose, setDisplayName } from "recompose";
import { connect } from "react-redux";

const mapStateToProps = (state, ownProps) => ({
  needsModifiedScrollbars: getNeedsModifiedScrollbars(state, ownProps),
});

export default compose(
  setDisplayName("ScrollAreaContainer"),
  connect(mapStateToProps),
)(ScrollAreaComponent);
